import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserDataContext } from "../components/UserDataContext";
import VN from "../components/VN";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Row, Col, Container } from "react-bootstrap";
import { marginBottom } from "../App";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

export default function Menu() {
  const navigate = useNavigate();
  const { userData } = useContext(UserDataContext);

  const card = (
    <>
      <ThemeProvider theme={theme}>
        <CardContent>
          <h1> BIURO RACHUNKOWE PRIOR</h1>
          {userData && ["1", "3"].includes(userData.permId) && (
            <Row style={{ marginBottom }}>
              <Col style={{ marginBottom }}>
                <Typography variant="h6" component="div">
                  {bull} Kompleksowa obsługa księgowa dla firm i osób fizycznych
                </Typography>
                <Typography variant="body2">
                  – Prowadzenie ksiąg, rozliczenia podatkowe, kadry i płace.
                </Typography>
              </Col>
            </Row>
          )}
          {userData && (userData.permId === "1" || userData.permId === "3") && (
            <Row style={{ marginBottom }}>
              <Col style={{ marginBottom }}>
                <Typography variant="h6" component="div">
                  {bull} Bezpłatna konsultacja na start – zapytaj o ofertę
                </Typography>
                <Typography variant="body2">
                  – Szybki kontakt i indywidualna wycena dla nowych klientów.
                </Typography>
              </Col>
            </Row>
          )}
          <Row style={{ marginBottom }}>
            <Col style={{ marginBottom }}>
              <Typography variant="h6" component="div">
                {bull} Gwarancja bezpieczeństwa i terminowości
              </Typography>
              <Typography variant="body2">
                – Ubezpieczenie OC biura, pełna poufność danych i aktualna
                wiedza o przepisach.
              </Typography>
            </Col>
          </Row>

          <Row style={{ marginBottom }}>
            <Col style={{ marginBottom }}>
              <Typography variant="h6" component="div">
                {bull} Przejrzyste ceny, żadnych ukrytych kosztów
              </Typography>
              <Typography variant="body2">
                – Jasne warunki współpracy i elastyczny cennik.
              </Typography>
            </Col>
          </Row>
        </CardContent>
      </ThemeProvider>
    </>
  );

  return (
    <div>
      <VN userData={userData} />
      <Container>
        <Box sx={{ maxWidth: 1200 }}>
          <Card variant="outlined">{card}</Card>
        </Box>
      </Container>
    </div>
  );
}
